<template>
  <div class="fixed bottom-3 left-3 z-30">
    <notification-bar v-for="notification in notifications" :key="notification.id"
      :notification="notification"
      class="mt-3" />
  </div>
</template>

<script>
import NotificationBar from '@/components/notifications/NotificationBar.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    NotificationBar,
  },

  computed: {
    ...mapGetters({
      notifications: 'notification/notifications',
    }),
  },
};
</script>
